import React from 'react'

export default function BetaLabel() {
    return <span className="beta-feature">BETA</span>
}